import { atom } from 'recoil';
import { SortingDirectionType } from 'app/global/constants/sortingDirectionEnums';

export const interfaceSortingDirection = atom({
  key: 'interfaceSortingDirection',
  default: SortingDirectionType.Descending,
});
